import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { onlyShowMetrics, isMetricsDisabled, calculateAvailableMetrics } from 'utils/metricesHelper';

import Metrices from 'configs/dashboardMetrices';


const MetricAction = ({
  name, component, onMetricsSelected, isSelected
}) => {
  const status = isSelected.includes(component.name.toLowerCase());

  const iconStyle = status ? 'metric-icon-active' : '';
  const onSelect = !status ? onMetricsSelected : () => { };

  return (
    <div className={`metric-icon ${iconStyle}`} onClick={() => onSelect(name, component.name.toLowerCase())}>
      <FontAwesomeIcon icon={component.icon} />
    </div>
  );
};

MetricAction.propTypes = {
  name: PropTypes.string,
  component: PropTypes.string,
  onMetricsSelected: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
};

MetricAction.defaultProps = {
  name: '',
  component: '',
  isSelected: true,
};

const MetricsActions = ({
  name, components, onMetricsSelected, isSelected
}) => (
    <div className="metric-actions">
      {components.map(component => (
        <MetricAction
          isSelected={isSelected}
          name={name}
          onMetricsSelected={onMetricsSelected}
          component={component}
        />
      ))}
    </div>
  );

MetricsActions.propTypes = {
  name: PropTypes.string,
  components: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  onMetricsSelected: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
};

MetricsActions.defaultProps = {
  name: '',
  components: [],
  isSelected: true,
};

const MetricList = ({ metric, dashboardComponents, onMetricsSelected }) => {
  const { name } = metric;
  const isSelected = isMetricsDisabled(dashboardComponents, name);

  const allowedSupportedMetrics = onlyShowMetrics(metric);

  if (allowedSupportedMetrics.length < 1) {
    return null;
  }

  return (
    <div className="row justify-content-between metric-item">
      {name}
      <div>
        <MetricsActions
          isSelected={isSelected}
          name={name}
          onMetricsSelected={onMetricsSelected}
          components={allowedSupportedMetrics}
        />
      </div>
    </div>
  );
};

MetricList.propTypes = {
  metric: PropTypes.shape({
    name: PropTypes.string,
    supportedComponents: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      })
    ),
  }).isRequired,
  dashboardComponents: PropTypes.arrayOf(
    PropTypes.shape({
      layout_config: PropTypes.shape({
        i: PropTypes.string,
        x: PropTypes.number,
        y: PropTypes.number,
        w: PropTypes.number,
        h: PropTypes.number,
        static: PropTypes.bool,
      }),
    })
  ).isRequired,
  onMetricsSelected: PropTypes.func.isRequired,
};

const SelectMetricesModal = ({
  isVisible,
  toggleModal,
  dashboardComponents,
  onMetricsSelected,
}) => (
    <Modal className="select-metrics-modal" isOpen={isVisible} toggle={toggleModal}>
      <ModalHeader>
        <div className="metric-title">Measures of success</div>
        <div className="metric-active">
          {`${dashboardComponents.length} of ${calculateAvailableMetrics(Metrices)} active`}
        </div>
      </ModalHeader>
      <ModalBody>
        {Metrices.map(metric => (
          <MetricList
            key={metric.name}
            dashboardComponents={dashboardComponents}
            onMetricsSelected={onMetricsSelected}
            metric={metric}
          />
        ))}
      </ModalBody>
    </Modal>
  );

SelectMetricesModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dashboardComponents: PropTypes.arrayOf(
    PropTypes.shape({
      layout_config: PropTypes.shape({
        i: PropTypes.string,
        x: PropTypes.number,
        y: PropTypes.number,
        w: PropTypes.number,
        h: PropTypes.number,
        static: PropTypes.bool,
      }),
    })
  ),
  onMetricsSelected: PropTypes.func.isRequired,
};

SelectMetricesModal.defaultProps = {
  dashboardComponents: [],
};

export default SelectMetricesModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/SelectMetricsModal.js